import { SMS_COUNTDOWN_TIMESTAMP } from "@/constants";
import { cn, createBEM } from "@/libs";
import { selectorLocalStorage, useLocalStorage } from "@/stores";
import { ComponentBase } from "@/types";
import tools from "@/utils/tool";
import { Button, SpinLoading, Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { makePlatformOnClick } from "../utils";
import "./index.scss";

export interface SMSButtonProps extends ComponentBase.Component {
  countdown?: number;
  sendSMS: () => Promise<boolean>;
}
export const SMSButton = ({
  className,
  countdown = 60,
  sendSMS,
  ...rest
}: SMSButtonProps) => {
  const b = createBEM("i-sms-button");

  const [timestamp, setTimeStamp] = useLocalStorage<number>(
    SMS_COUNTDOWN_TIMESTAMP
  )(selectorLocalStorage);

  let defDuration: number = 1000,
    defCountdown = countdown,
    defIsCounting = false;

  if (tools.isNumber(timestamp)) {
    const now = Date.now();
    const diff = now - timestamp;
    const left = countdown * 1000 - diff;
    if (left > 0) {
      const mod = left % 1000;
      const leftCountdown = (left - mod) / 1000;
      defDuration = mod;
      defCountdown = leftCountdown;
      defIsCounting = true;
    }
  }

  const [loading, setLoading] = useState(false);
  const [duration, setduration] = useState(defDuration);
  const [isCounting, setIsCounting] = useState(defIsCounting);
  const [countdownStr, setCountdownStr] = useState(defCountdown);
  const _onClick = () => {
    if (loading) return Toast.show("请勿重复点击");
    if (isCounting) return Toast.show(`请${countdownStr}s后再试`);
    setLoading(true);
    sendSMS().then((ok) => {
      setLoading(false);
      if (ok) {
        if (!isCounting) {
          setTimeStamp(Date.now());
          setIsCounting(true);
        }
      }
    });
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isCounting) {
      timer = setTimeout(() => {
        setduration(1000);
        setCountdownStr((v) => {
          let nextCountdown = v - 1;
          if (nextCountdown <= 0) {
            nextCountdown = countdown;
            setIsCounting(false);
          }
          return nextCountdown;
        });
      }, duration);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isCounting, countdownStr, countdown, duration]);

  const buttonContent = isCounting ? `${countdownStr}s` : "|  获取验证码";

  return (
    <Button
      className={cn(b(), className)}
      {...rest}
      fill="none"
      {...makePlatformOnClick((e) => {
        e.preventDefault();
        _onClick();
      })}
    >
      {loading ? <SpinLoading /> : buttonContent}
    </Button>
  );
};
